import printWeekHeaderUrl from './printWeekHeader.html';
export default {
  templateUrl: printWeekHeaderUrl,
  controllerAs: 'ctrl',
  bindings: {
    currentDays: '<',
    processingMode: '<',
  },
};
